import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import BarLoader from 'react-spinners/BarLoader';
import { useGetAvailableEventListQuery } from '../../services/api/apiProvider';
import { ResponseEvent } from '../../services/api/models/response/responseEvent';
import { TopPageEventItem } from './components/TopPageEventItem';

import './Events.scss';

/**
 * Event list component
 * @returns React component for event list
 */
export const Events = (): ReactElement => {
  const {
    data: listEvents,
    isFetching,
    isLoading,
  } = useGetAvailableEventListQuery();

  const [showEventModal, setShowEventModal] = useState<boolean>(false);
  const currentShowEvent = useRef<ResponseEvent | null>(null);

  const handleCloseEventModal = () => {
    setShowEventModal(false);
  };

  const openEventDetailModal = (event: ResponseEvent) => {
    window.open(event.uri);
  };

  // setup title
  useEffect(() => {
    document.title = 'Web版everylive（エブリライブ） - Events';
  }, []);

  /**
   * Event detail modal
   */
  const renderEventModal = () => {
    if (currentShowEvent.current == null) {
      return <></>;
    }

    return (
      <Modal
        show={showEventModal}
        onHide={handleCloseEventModal}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{currentShowEvent.current.name}</Modal.Title>
        </Modal.Header>
        <iframe
          src={currentShowEvent.current.uri}
          className="event-modal__details"
        ></iframe>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseEventModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <div className="events">
      {isLoading || isFetching ? (
        <BarLoader color={'#0275d8'} width="100%" cssOverride={{}}></BarLoader>
      ) : (
        <div className="events__list">
          {showEventModal ? renderEventModal() : <></>}
          {listEvents?.map((event) => {
            return (
              <div
                className="events__list__item"
                key={event.id}
                onClick={() => {
                  openEventDetailModal(event);
                }}
              >
                <TopPageEventItem {...event}></TopPageEventItem>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
